import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import Strategy from "@/components/landing/Strategy";
import Process from "@/components/landing/Process";
import About from "@/components/landing/About";
import Leadership from "@/components/landing/Leadership";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import IntroducingPost from "@/components/post/IntroducingPost";
import OgCard from "@/components/post/OgCard";

function Landing() {
  return (
    <div className="bg-vignette bg-grain min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Strategy />
        <Process />
        <About />
        <Leadership />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/post/introducing" element={<IntroducingPost />} />
          <Route path="/og" element={<OgCard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
